import { clsx } from 'clsx';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={clsx(className)}
      style={{
        background: `linear-gradient(90deg,
          var(--nucleo-surface-up) 0%,
          var(--nucleo-surface-sel) 50%,
          var(--nucleo-surface-up) 100%)`,
        backgroundSize: '200% 100%',
        animation: 'n-shimmer 1.4s linear infinite',
      }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="p-5 space-y-3" style={{ background: 'var(--nucleo-surface)', border: '1px solid var(--nucleo-line)' }}>
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-7 w-16" />
      <Skeleton className="h-2 w-32" />
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="space-y-2">
      <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-full" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="grid gap-4" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
          {Array.from({ length: cols }).map((_, j) => (
            <Skeleton key={j} className="h-8 w-full" />
          ))}
        </div>
      ))}
    </div>
  );
}
